/*eslint-disable */
import React, { useEffect, useState } from "react";
import MenuLayouts from "../layouts/menu.layout";
import FooterLayouts from "../layouts/footer.layout";
import BtnFloatingLayout from "../layouts/btn_flotante.layout";
import OtrosVehiculosComponent from "../components/vehiculos-detail/otros-vehiculos.component";
import LastNewsComponent from "../components/noticias/last_news.component";
import AllNewsComponent from "../components/noticias/all_news.component";
import { lastNewsforCategories, NewsOneForDate } from "../components/conexion/blogs.conexion";
import { useParams } from "react-router-dom";
import OtrosVehiculosDinamicoComponent from "../components/vehiculos-detail/otros-vehiculos-dinamico.component";

/*eslint-disable */

const NoticiasPage: React.FC = () => {
  const { category } = useParams<{ category?: string }>();
  const [visibleHeight, setVisibleHeight] = useState(0);
  const [lastNewsData, setLastNewsData]: any = useState([]);
  const [newsForCategories, setNewsForCategories]: any = useState([]);
  const [opportunities, setOpportunities]: any = useState([]);

  useEffect(() => {
    lastNewsforCategories().then(function (res: any) {
      setNewsForCategories(res?.data?.data[0])
      setOpportunities(res?.data?.data[0].Opportunities)

    })
    NewsOneForDate().then(function (res: any) {
      setLastNewsData(res?.data?.data)
    })
  }, [])
  
  return (
    <>
      <MenuLayouts className="home-page" active="somos"  setVisibleHeight={setVisibleHeight} visibleHeight={visibleHeight} />
      <div className="home-page" /* style={{backgroundColor: "#F6F3F2", height: "100vh"}} */>
        <div className="home-page-mascara"></div>
        <LastNewsComponent lastNewsData={newsForCategories} category={category}/>
        <AllNewsComponent newsForCategories={newsForCategories} category={category}/>
        <OtrosVehiculosDinamicoComponent opportunities={opportunities} />
      </div>
      <BtnFloatingLayout reserva="https://reservas.hyundaicolombia.co/" />
      <FooterLayouts />
    </>
  );
};

export default NoticiasPage;
